import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
} from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { FormattedMessage, useIntl } from 'react-intl';
import DialogTemplate from 'components/shared/DialogTemplate';
import ExpansionSection from 'components/templates/ExpansionSection';
import { Input } from 'components/FormInputs';
import { validatePatched } from 'logic/cottage';
import { useFormik } from 'components/shared/Formik';

const title = (
  <FormattedMessage
    id="Title"
    defaultMessage="Title"
  />
);

const description = (
  <FormattedMessage
    id="Description"
    defaultMessage="Description"
  />
);

const langs = {
  sv: (
    <FormattedMessage
      id="Swedish"
      defaultMessage="Swedish"
    />
  ),
  en: (
    <FormattedMessage
      id="English"
      defaultMessage="English (not required)"
    />
  ),
  de: (
    <FormattedMessage
      id="German"
      defaultMessage="German (not required)"
    />
  ),
};

const EditTexts = ({
  isLoading,
  onSubmit,
  onClose,
  cottage,
}) => {
  const [expanded, setExpanded] = React.useState('sv');
  const intl = useIntl();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const formik = useFormik({
    initialValues: {
      title_sv: '',
      title_de: '',
      title_en: '',
      description_sv: '',
      description_en: '',
      description_de: '',
      ...cottage,
    },
    enableReinitialize: true,
    validate: validatePatched({ intl, dialog: 'text' }),
    validateOnBlur: true,
    validateOnChange: false,
    onSubmit: async (values) => {
      await onSubmit(values);
    },
  });

  const togglePanel = (lang) => setExpanded(lang === expanded ? null : lang);

  const {
    values, errors, handleSubmit, handleChange, submitForm, handleBlur,
  } = formik;

  const dirty = Object.keys(langs)
    .some((lang) => cottage[`title_${lang}`] !== (values[`title_${lang}`] || null) || cottage[`description_${lang}`] !== (values[`description_${lang}`] || null));

  return (
    <DialogTemplate
      title={(
        <>
          <FormattedMessage
            id="Texts"
            defaultMessage="Texts"
          />
          &nbsp;
          <>
            #{cottage?.id}
            {
              !isSmall && (
                <>{cottage?.title_sv ? <> - "{cottage?.title_sv}"</> : ''}</>
              )
            }
          </>
        </>
      )}
      onSave={submitForm}
      pristine={!dirty}
      onClose={onClose}
      isUpdating={isLoading}
    >
      <form onSubmit={handleSubmit} noValidate>
        {Object.keys(langs).map((lang) => (
          <ExpansionSection
            key={lang}
            summary={langs[lang]}
            expanded={expanded === lang}
            divider
            onChange={() => togglePanel(lang)}
          >
            <Box flex={1}>
              <Input
                name={`title_${lang}`}
                value={values[`title_${lang}`]}
                errors={errors}
                label={title}
                onChange={handleChange}
                onBlur={handleBlur}
                required={lang === 'sv'}
                inputProps={{ maxLength: 50 }}
              />
              <Input
                name={`description_${lang}`}
                value={values[`description_${lang}`]}
                errors={errors}
                label={description}
                onChange={handleChange}
                onBlur={handleBlur}
                required={lang === 'sv'}
                multiline
                rows={8}
              />
            </Box>
          </ExpansionSection>
        ))}
      </form>
    </DialogTemplate>
  );
};

EditTexts.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  cottage: PropTypes.shape({
    id: PropTypes.number,
    title_sv: PropTypes.string,
  }),
};

export default EditTexts;
